import axios from "axios";
import { baseBackUrl } from "../assets/linkTree";

class AuthService {
  login(user) {
    return axios
      .post(baseBackUrl + "api" + "/auth/signin", {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          axios.post(baseBackUrl + "api/token", {
            token: response.data.accessToken
          });
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }
  logout() {
    axios.delete(baseBackUrl + "api/token");
    sessionStorage.clear();
    localStorage.removeItem("user");
  }
}

export default new AuthService();



// WEBPACK FOOTER //
// ./src/services/auth.service.js